import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PDFIcon from '@material-ui/icons/PictureAsPdfOutlined';
import LockIcon from '@material-ui/icons/LockOutlined';

import pdfPreviewImage from '../../assets/img/pdf_preview.jpg';
import * as constants from '../../config/constants';
import classes from '../../css/getCSS';


const profilePDF = (props) => {
  let pdfs = (
    <div align="center" style={{ padding: '20px', width: '100%' }}>
      <LockIcon />
      <Typography variant="body1">
        PDF Bio Data is Locked!
        <br />
        The candidate must accept your interest or request to be able to view the file.
      </Typography>
    </div>
  );
  // eslint-disable-next-line
  if (props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted
    || true
  ) {
    pdfs = props.profile.pdfs.map((item) => {
      const src = constants.BASE_URL + item.file;
      return (
        <Grid item md={3} sm={3} xs={6} key={item.id}>
          <a href={src} target="_blank" rel="noopener noreferrer">
            <img alt={item.id} src={pdfPreviewImage} className={classes.profilePhoto} />
          </a>
        </Grid>
      );
    });
  }

  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('pdfs')}>Edit</Button>
    );
  }

  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <PDFIcon className={classes.titleIcon} />
          Attached Bio Data
        </Typography>
        <br />
        <Grid container>
          {pdfs}
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default profilePDF;



// WEBPACK FOOTER //
// ./src/profile/components/ProfilePDFs.js